export default {
  title: 'QR Codes bucket history',
  name: 'Name',
  qrcodes: 'QR Codes',
  date: 'Date',
  pdf: 'PDF'
}
